// @flow
import React from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { ProductProgram } from 'Components/widgets/product-program/ProductProgram';
import { type TourProgramDescriptorProps } from 'Client/cms/toolkit/tour-program/tourProgram.resolver.js';

type Props = {
  ...$Exact<TourProgramDescriptorProps>,
  id?: string,
};

export function TourProgramLine({ id, ...props }: Props) {
  const { stopover = {} } = props;
  const { tour = {}, extension = {} } = stopover;

  return (
    <SiteContainer id={id} className="Line">
      <ProductProgram
        isDetailed={props.isDetailed}
        extension={{
          title: extension.title,
          subtitle: extension.duration,
          stops: extension.stops,
        }}
        program={{
          title: tour.title,
          subtitle: tour.duration,
          stops: tour.stops,
        }}
      />
    </SiteContainer>
  );
}
